import { render, staticRenderFns } from "./VehicleQuickInfo.vue?vue&type=template&id=2c3b796a&lang=pug&"
import script from "./VehicleQuickInfo.vue?vue&type=script&lang=ts&"
export * from "./VehicleQuickInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleQuickInfo.vue?vue&type=style&index=0&id=2c3b796a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports